<template>
    <ul v-if="packages.length">
        <li v-for="packageItem in packages">
            <a :href="packageItem._links.frontend[linkKey]"><strong>{{ packageItem.project }}: </strong>{{ packageItem.name }} <i>({{ packageItem.reference }})</i></a>
        </li>
    </ul>
</template>

<script>
    export default {
        props: ['route'],
        data: function () {
            return {
                packages: []
            };
        },
        computed: {
            linkKey: function () {
                if (this.route) {
                    return this.route;
                }

                return 'view';
            }
        },
        methods: {
            getPackages: function () {
                this.packages = [];

                var that = this;

                axios.get(appUrls.users.last_packages)
                    .then(response => {
                        that.packages = response.data.data;
                    });
            }
        },
        mounted() {
            this.getPackages();
        }
    }
</script>


<style lang="scss" scoped>

</style>
